import { styled } from '@mui/material';

// import { TagsInput } from '../TagsInput';

import { WsAutocompleteInput } from '../WsAutocompleteInput';
const EmailInputField = styled(WsAutocompleteInput)(() => ({
  '.MuiOutlinedInput-root': {
    fieldset: {
      border: 'none',
    },
    padding: 0,
    margin: 0,
  },
  ':inputProps': {
    padding: 0,
  },
}));

export default EmailInputField;
